import { render, staticRenderFns } from "./AllTask.vue?vue&type=template&id=37349852&scoped=true&"
import script from "./AllTask.vue?vue&type=script&lang=js&"
export * from "./AllTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37349852",
  null
  
)

export default component.exports